import { jsx as l } from "react/jsx-runtime";
import { c as s } from "../clsx-OuTLNxxd.js";
import { T as d, h as m, g as u, a as _, d as p, c as T, e as i } from "../Table-FUhkkUOD.js";
import { T as C } from "../TableScrollContainer-BHZ9DQBw.js";
import '../StatsTable.css';const w = "_wrapper_oupcu_32", y = "_table_oupcu_54", h = "_tableHead_oupcu_62", N = "_tableColumn_oupcu_70", S = "_tableBody_oupcu_84", B = "_tableRow_oupcu_88", F = "_tableCell_oupcu_91", H = "_tableFooter_oupcu_101", o = {
  wrapper: w,
  table: y,
  tableHead: h,
  tableColumn: N,
  tableBody: S,
  tableRow: B,
  tableCell: F,
  tableFooter: H
}, c = ({
  caption: e,
  cellWidth: t = 60,
  children: a,
  className: n,
  maxRows: b,
  ...r
}) => /* @__PURE__ */ l(
  C,
  {
    caption: e,
    cellWidth: t,
    className: s(o.wrapper, n),
    "data-cxy-name": "stats-table",
    maxRows: b,
    ...r,
    children: /* @__PURE__ */ l(d, { className: o.table, "data-testid": "stats-table", children: a })
  }
), R = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(m, { className: s(o.tableRow, t), size: "s", ...a, children: e }), g = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  p,
  {
    className: s(o.tableColumn, t),
    "data-justify": a,
    "data-pinned": n,
    "data-type": "heading",
    justifyContent: a,
    ...b,
    children: e
  }
), f = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  T,
  {
    className: s(o.tableCell, t),
    "data-highlight": !!b.highlight,
    "data-justify": a,
    "data-pinned": n,
    justifyContent: a,
    ...b,
    children: e
  }
), x = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(i, { ...a, className: s(o.tableFooter, t), children: e }), j = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(u, { ...a, className: s(o.tableHead, t), children: e }), z = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(_, { className: s(o.tableBody, t), ...a, children: e });
c.Row = R;
c.Head = j;
c.Body = z;
c.Column = g;
c.Cell = f;
c.Footer = x;
export {
  c as StatsTable
};
